'use client';

import { useAnalytics } from 'hooks/useAnalytics';
import { cn } from 'lib/utils';
import PropTypes from 'prop-types';
import { POSTHOG_SIGNUP_EVENT_WEB_CHAT } from 'utilities/analytics';

const BASE_CLASSES =
  'text-sm hyphens-none whitespace-nowrap uppercase font-mono tracking-wider bg-stone-200 text-stone-700 dark:bg-stone-700 dark:text-stone-300 rounded-lg px-2 py-1 dark:hover:bg-amber-400 dark:hover:text-black transition-colors shadow-sm hover:bg-pink-700 hover:text-white mx-1 no-underline';

const Bubble = ({ className = '', children, ...props }) => {
  const { trackEvent } = useAnalytics();

  // Every bubble is a web chat entry point, so track it as one. Bubbles sit
  // inline in prose ("text RESIST to 50409"), which is why they stay on web
  // chat rather than deep linking Apple devices the way the CTAs do.
  //
  // Most bubbles are account instructions for people who already signed up
  // (ACCOUNT, PREMIUM END, CLEAR), so the keyword is what separates a real
  // signup from housekeeping. Without it these clicks silently inflate the
  // signup metric they were added to measure.
  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
    trackEvent({
      eventName: POSTHOG_SIGNUP_EVENT_WEB_CHAT,
      eventData: { placement: 'bubble', keyword: children },
    });
  };

  return (
    <a
      className={cn(BASE_CLASSES, className)}
      href={`/chat?trigger=${children}`}
      {...props}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

Bubble.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Bubble;
